"use client"

import { ResponsiveHeader } from "@/components/responsive-header"

export function TemplatesHeader() {
  return <ResponsiveHeader />
}
